import { Heart, Wheat } from "lucide-react";
import { useEffect, useMemo, useState } from "react";

function differenceInDays(target: Date, now: Date) {
  return Math.ceil((target.getTime() - now.getTime()) / 86_400_000);
}

export function Countdown({ weddingDate }: { weddingDate: string }) {
  const [now, setNow] = useState(() => new Date());
  const target = useMemo(
    () => (weddingDate ? new Date(weddingDate) : null),
    [weddingDate],
  );

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  const validTarget = target && !Number.isNaN(target.getTime()) ? target : null;
  const days = validTarget ? differenceInDays(validTarget, now) : null;
  const label =
    days === null
      ? "Termín brzy doplníme"
      : days > 1
        ? `${days} dní do svatby`
        : days === 1
          ? "Zítra si řekneme ano"
          : days === 0
            ? "Dnes je ten den"
            : `Jsme svoji ${Math.abs(days)} dní`;

  return (
    <section className="countdown" aria-label="Odpočet do svatby">
      <div className="countdown__inner">
        <div>
          <span className="eyebrow">Cesta k jednomu ano</span>
          <strong>{label}</strong>
        </div>
        <div className="countdown__track" aria-hidden="true">
          <span className="countdown__person countdown__person--first">M</span>
          <span className="countdown__line">
            <Wheat size={18} />
            <span />
            <Heart className="countdown__heart" size={29} fill="currentColor" />
            <span />
            <Wheat size={18} />
          </span>
          <span className="countdown__person countdown__person--second">T</span>
        </div>
      </div>
    </section>
  );
}
